@if (link === openMenuItem) {
  <div
    class="NavLink__Menu"
    [ngStyle]="{ height: scrollHeight + 'px' }"
    [ngClass]="{
      'NavLink__Menu--Right': link.menuRightAlign,
    }"
    #exapandableContent
  >
    @for (item of openMenuItem.items; track item) {
      <ds-link
        class="NavLink__Option"
        [ngClass]="{
          'NavLink__Option--Active':
            data.activeNavItem && item === data.activeNavItem,
        }"
        tabindex="0"
        [linkConfig]="getLinkConfig(item)"
        [externalSiteModalConfig]="externalSiteModalConfig"
        (linkClicked)="onLinkClick($event, item)"
        (openExternalLinkModal)="$event.stopPropagation()"
      >
        <div class="u-flex u-alignCenter">
          <h2 class="NavLink__Name t-bold" [innerHTML]="item.label"></h2>
          @if (item.isExternalRoute && link.showIcon) {
            <icon
              [name]="item.icon ? item.icon : 'open_in_new'"
              [config]="{
                type: 'link',
                fill: 'nav-link-icon-color',
              }"
            ></icon>
          }
        </div>
        <p class="NavLink__Description" [innerHTML]="item.description"></p>
      </ds-link>
    }
  </div>
}
